import { useRedirectToToday } from '@hooks/useRedirectToToday';

type RedirectToTodayProps = {
  basePath: string;
};

const RedirectToToday = ({ basePath }: RedirectToTodayProps) => {
  useRedirectToToday(basePath);

  return null;
};

export { RedirectToToday };
